import { Icon } from '@chakra-ui/react';
import { MdBarChart, MdHome, MdLock, MdOutlineShoppingCart, MdPerson } from 'react-icons/md';

// Admin Imports
import DataTables from 'views/admin/dataTables';
import MainDashboard from 'views/admin/default';
import AddFormation from 'views/admin/formations/add';
import CurrentCourse from 'views/admin/formations/CurrentCourse';
import SingleFormation from 'views/admin/formations/SingleFormation';
import UpdateFormation from 'views/admin/formations/update';
import NFTMarketplace from 'views/admin/marketplace';
import Profile from 'views/admin/profile';


// Auth Imports
import CourseViewer from 'views/admin/formations/CourseViewer';
import CurrentTest from 'views/admin/formations/CurrentTest';
import Questions from 'views/admin/formations/CurrentTest/questions';
import Certificate from 'views/admin/profile/certificate/Certificate';
import SignInCentered from 'views/auth/signIn';
import Signup from 'views/auth/signIn/Signup';


const routes = [
	{
		roles: [1],
		name: 'Tableau de bord ',
		layout: '/admin',
		path: '/default',
		icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
		component: MainDashboard
	},
	{	roles: [5],
		name: 'Ajouter des formations',
		layout: '/formateur',
		icon: <Icon as={MdBarChart} width='20px' height='20px' color='inherit' />,
		path: '/add',
		component: AddFormation
	},
	{
		roles: [2,3,4,5],
		name: 'Certificate',
		layout: '/user',
		icon: <Icon as={MdBarChart} width='20px' height='20px' color='inherit' />,
		path: '/profile/certificate',
		component: Certificate
	},
	{	roles: [5],
		name: 'Gestion des formations',
		secondary:true,
		layout: '/formations',
		icon: <Icon as={MdBarChart} width='20px' height='20px' color='inherit' />,
		path: '/update',
		component: UpdateFormation
	},
	{
		roles: [2,3,4,5],
		name: 'Formations',
		layout: '/user',
		path: '/formations',
		icon: <Icon as={MdOutlineShoppingCart} width='20px' height='20px' color='inherit' />,
		component: NFTMarketplace,
		secondary: true
	},
	{
		roles: [5],
		name: 'Formations',
		layout: '/formateur',
		path: '/formations',
		icon: <Icon as={MdOutlineShoppingCart} width='20px' height='20px' color='inherit' />,
		component: NFTMarketplace,
		secondary: true
	},
	{
		roles: [2,3,4,5],
		name: 'Single',
		layout: '/formations',
		path: '/single',
		icon: <Icon as={MdOutlineShoppingCart} width='20px' height='20px' color='inherit' />,
		component: SingleFormation
	},
	
	{
		roles: [2,3,4,5],
		name: 'Course',
		layout: '/course',
		path: '/get',
		icon: <Icon as={MdOutlineShoppingCart} width='20px' height='20px' color='inherit' />,
		component: CurrentCourse
	},
	{roles: [2,3,4,5],
		name: 'Test',
		layout: '/test',
		path: '/get',
		icon: <Icon as={MdOutlineShoppingCart} width='20px' height='20px' color='inherit' />,
		component: CurrentTest
	},
	{roles: [2,3,4,5],
		name: 'Read Course',
		layout: '/course',
		path: '/read',
		icon: <Icon as={MdOutlineShoppingCart} width='20px' height='20px' color='inherit' />,
		component: CourseViewer
	},
	{roles: [2,3,4,5],
		name: 'Questions',
		layout: '/test',
		path: '/questions',
		icon: <Icon as={MdOutlineShoppingCart} width='20px' height='20px' color='inherit' />,
		component: Questions
	},
	{roles: [1],
		name: 'Tables des données',
		layout: '/admin',
		icon: <Icon as={MdBarChart} width='20px' height='20px' color='inherit' />,
		path: '/data-tables',
		component: DataTables
	},
	{roles: [1],
		name: 'Gestion Formation',
		layout: '/admin/formation',
		icon: <Icon as={MdBarChart} width='20px' height='20px' color='inherit' />,
		path: '/gestion',
		component: DataTables
	},
	{roles: [2,3,4,5],
		name: 'Profile',
		layout: '/user',
		path: '/profile',
		icon: <Icon as={MdPerson} width='20px' height='20px' color='inherit' />,
		component: Profile
	},
	{
		roles: [2,3,4,5],
		name: 'Profile',
		layout: '/formateur',
		path: '/profile',
		icon: <Icon as={MdPerson} width='20px' height='20px' color='inherit' />,
		component: Profile
	},
	{
		roles: [1,2,3,4,5],
		name: 'Sign In',
		layout: '/auth',
		path: '/sign-in',
		icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
		component: SignInCentered
	},
	{roles: [1,2,3,4,5],
		name: 'Sign Up',
		layout: '/auth',
		path: '/sign-up',
		icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
		component: Signup
	}
];

export default routes;
